import { useEffect } from 'react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { HStack, Text } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { toNumber } from 'lodash'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { DARK_TEXT_MUTED } from 'constants/dark-tokens'
import routes from 'routes'

// Breadcrumb tail for the dark group-member header (rendered inside
// PlayPageHeader, which owns the leading home icon + first chevron).
function UserPageHeader() {
  const { groupStore } = useStores()
  const { groupDetail } = groupStore
  const url = window.location.href ?? ''
  const match = url?.match(/groups\/(\d+)/)
  const groupId = match !== null ? toNumber(match[1]) : 0
  const navigate = useNavigate()

  useEffect(() => {
    groupStore.getGroupDetail(groupId)
  }, [groupId])

  return (
    <HStack as="span" spacing="8px" overflow="hidden">
      <Text
        as="span"
        color={DARK_TEXT_MUTED}
        fontWeight={500}
        fontSize="16px"
        m={0}
        cursor="pointer"
        flexShrink={0}
        _hover={{ color: '#F2F7FA' }}
        onClick={() => navigate(routes.groups.value)}
      >
        Player groups
      </Text>
      <ChevronRightIcon color={DARK_TEXT_MUTED} flexShrink={0} />
      <Text as="span" color="#F2F7FA" fontWeight={600} fontSize="16px" m={0} noOfLines={1}>
        {groupDetail?.name ?? ''}
      </Text>
    </HStack>
  )
}

export default observer(UserPageHeader)
